export const SET_LOADINGS = "set/loadings";

export const setLoadings = payload => ({
  type: SET_LOADINGS,
  payload
})